escape_list = (list) ->
  _.map list, (value) ->
    value.text = escapeHtml(value.text)
    value

init_search_dialog = ->
  @INPUT_SELECTOR = '.navbar #search-dialog'

  placeholder = __('search.placeholder')

  $(@INPUT_SELECTOR).select2 {
    width: '250',
    dropdownAutoWidth : true,
    placeholder: placeholder,
    minimumInputLength: 1,
    multiple: true,
    closeOnSelect: false,
    ajax:
      delay: 500
      transport: (params, success, failure) ->
        deferred = $.Deferred()
        adertisersRequest = $.get "/ajax/v2/advertisers/search", {q: params.data.q, limit: 3}
        campaignGroupsRequest = $.get "/ajax/v2/campaign_groups/search", {q: params.data.q, limit: 3}
        campaignsRequest = $.get "/ajax/v2/campaigns/search", {q: params.data.q, limit: 3}
        creativesRequest = $.get "/ajax/v2/creatives/search", {q: params.data.q, limit: 3}

        $.when(adertisersRequest, campaignGroupsRequest, campaignsRequest, creativesRequest).done (adertisersResponse, campaignGroupsResponse, campaignsResponse,  creativesResponse) ->
          list = []
          if adertisersResponse[1] is 'success' and adertisersResponse[0].length
            list.push({
              id: 'advertisers',
              groupTitle: true,
              text: "<div class='search-result-group'>#{__('search.result.group.advertiser')}</div>",
              children: escape_list adertisersResponse[0]
            })
          if campaignGroupsResponse[1] is 'success' and campaignGroupsResponse[0].length
            list.push({
              id: 'campaign_groups',
              groupTitle: true,
              text: "<div class='search-result-group'>#{__('search.result.group.campaign_groups')}</div>",
              children: escape_list campaignGroupsResponse[0]
            })
          if campaignsResponse[1] is 'success' and campaignsResponse[0].length
            list.push({
              id: 'campaigns',
              groupTitle: true,
              text: "<div class='search-result-group'>#{__('search.result.group.campaigns')}</div>",
              children: escape_list campaignsResponse[0]
            })
          if creativesResponse[1] is 'success' and creativesResponse[0].length
            list.push({
              id: 'creatives',
              groupTitle: true,
              text: "<div class='search-result-group'>#{__('search.result.group.creatives')}</div>",
              children: escape_list creativesResponse[0]
            })

          deferred.resolve {results: list}

        deferred.then success
        deferred.fail failure

        deferred
    dropdownCssClass: "search-dropdown",
    language:
      inputTooShort: () ->
        __('search.input-too-short')
    templateResult: (data) ->
      if data.id && !data.groupTitle
        return "<a class='search-result' target='_blank' href='#{data.url}'>#{data.text}</a>"
      else
        return data.text
    escapeMarkup: (m) ->
      return m
  }

  $(@INPUT_SELECTOR).on 'select2:selecting', (e) =>
    e.preventDefault()
